<div class="div-arriere-plan-action" (click)="onDismiss(true)"></div>
<div class="div-global-action" (click)="$event.stopPropagation()">
  <div id="center-square">
    <div style="display: flex; justify-content: space-between; flex-direction: column; height: 100%">
      <div class="p-20 text-center">
        <img class="close-icon" src="assets/close_cross_black.svg" (click)="onDismiss(true)">
        <img src="assets/add-icon.svg" alt="sent">
        <h3 class="bold header_title dark-blue">Profil modifié</h3>
      </div>

      <div class="p-20 flex content-between align-items-center bg-pale-blue">
        <div>
          <p class="grey no-margin">Ancien profil</p>
          <div class="flex gap-10 align-items-center">
            <p class="dark-blue no-margin">{{defineFullRole(oldProfile)}}</p>
            <app-custom-tag [isValidated]="true" [backgroundColor]="getRoleBackgroundColor(oldProfile)"
              [textColor]="'#2B2D67'" [text]="defineRole(oldProfile)" [fitContent]="true"></app-custom-tag>
          </div>
        </div>

        <div>
          <img src="assets/play-icon.svg" alt="arrow">
        </div>

        <div>
          <p class="grey no-margin">Nouveau profil</p>
          <div class="flex gap-10 align-items-center">
            <p class="dark-blue no-margin">{{defineFullRole(newProfile)}}</p>
            <app-custom-tag [isValidated]="true" [backgroundColor]="getRoleBackgroundColor(newProfile)"
              [textColor]="'#2B2D67'" [text]="defineRole(newProfile)" [fitContent]="true"></app-custom-tag>
          </div>
        </div>
      </div>

      <div class="p-20" style="display: grid; grid-template-columns: 1fr 1fr; gap: 20px;">
        <div>
          <p class="no-margin mb-10 grey no-margin mb-10">Nom <br /><span
              class="bold dark-blue">{{contactUpdated?.lastName}}</span></p>
          <p class="no-margin mb-10 grey no-margin mb-10">Prénom <br /><span
              class="bold dark-blue">{{contactUpdated?.firstName}}</span></p>
        </div>
        <div>
          <p class="no-margin mb-10 grey no-margin mb-10">Email <br /><span
              class="bold dark-blue">{{contactUpdated?.email}}</span></p>
          <p class="no-margin mb-10 grey no-margin mb-10">Invitation <br /><span
              class="bold dark-blue">{{contactUpdated?.sendInvitation ? 'Oui' : 'Non'}}</span></p>
        </div>
      </div>


      <div class="p-20 margin-center">
        <v8te-active-button [buttonText]="'Ok'" [primaryColor]="'#FFFFFF'" [textPrimaryColor]="'#2B2D67'"
          [border]="'solid 1px #D9D9D9'" [active]="true" (click)="onDismiss(true)" [height]="50" [minWidth]="190"
          [widthPercent]="50" [bold]="true"></v8te-active-button>
      </div>
    </div>
  </div>
</div>